import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocaleService } from './locale.service';

export function acceptLanguageInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const locale = inject(LocaleService).current;
  return next(req.clone({ setHeaders: { 'Accept-Language': locale } }));
}
